<template lang="pug">
.logoComponent(:class="{ _adaptive: isAdaptive }")
  a.logoWrapper(v-if="isHomepage" href="#")
    img.lecta(src="@/assets/images/lecta.svg")
    img.logo(src="@/assets/images/logo.svg")
    .text Начинайзер
  router-link(v-else :to="{ name: 'Catalog' }").logoWrapper
    img.lecta(src="@/assets/images/lecta.svg")
    img.logo(src="@/assets/images/logo.svg")
    .text Начинайзер

</template>

<script>
import { useRoute } from 'vue-router'
import { computed } from 'vue'

export default {
  props: {
    isAdaptive: {
      type: Boolean,
      default: false
    }
  },
  setup () {
    const route = useRoute()
    const isHomepage = computed(() => route.name === 'Home')

    return {
      isHomepage
    }
  }
}
</script>

<style lang="sass" scoped>
.logoComponent
  .logoWrapper
    display: flex
    align-items: center
    @include gap(4*$u)
    .lecta
      width: 74px
    .prosv
      width: 97px
    .logo
      width: 10*$u
    .text
      @include font('logo-bold')
      white-space: nowrap

  &._adaptive
    @media (max-width: $XXSWidth)
      .logoWrapper
        @include gap(2*$u)
      .lecta
        width: 52px
      .prosv
        width: 66px
      .logo
        width: 7.5*$u
      .text
        @include font('t16-demibold')
</style>
